import React, { useRef, useState, useEffect } from "react"
import { Pie } from "react-chartjs-2"
import { FaDownload } from "react-icons/fa"
import API from "../../api"

const StatsPieChart = () => {
  const chartRef = useRef(null)
  const [data, setData] = useState({
    labels: ["Complet", "En cours", "Jamais"],
    datasets: [],
  })

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 20,
          padding: 15,
        },
      },
    },
  }

  const userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  const annee_id = userAuthScolarite?.user?.annee_id

  const handleDownload = () => {
    const chart = chartRef.current
    if (!chart) return
    const base64Image = chart.toBase64Image()
    const link = document.createElement("a")
    link.href = base64Image
    link.download = "Statistique_des_emplois_de_groupes.png"
    link.click()
  }

  // 🔹 Récupération des données de l'API
  const fetchData = async () => {
    try {
      const res = await API.post("emploi/stat_emploi_grp", { annee_id })
      const resume = res.data.resume
      const semestre1 = resume.semestre_1
      const semestre2 = resume.semestre_2
      setData({
        labels: [
          "Complet S1",
          "En cours S1",
          "Jamais S1",
          "Complet S2",
          "En cours S2",
          "Jamais S2",
        ],
        datasets: [
          {
            data: [
              semestre1.Complet,
              semestre1["En cours"],
              semestre1.Jamais,
              semestre2.Complet,
              semestre2["En cours"],
              semestre2.Jamais,
            ],
            backgroundColor: [
              "#4CAF50", // Complet S1
              "#FF9800", // En cours S1
              "#F44336", // Jamais S1
              "#00f43a", // Complet S2
              "#f1c235", // En cours S2
              "#ff0202", // Jamais S2
            ],
            borderColor: "#fff",
            borderWidth: 2,
          },
        ],
      })
    } catch (error) {
      console.error("❌ Erreur API :", error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <div style={{ textAlign: "center" }}>
      <h3 style={{ color: "#4CAF50" }}>Statistique des emplois de groupes</h3>
      <FaDownload
        onClick={handleDownload}
        style={{
          cursor: "pointer",
          marginBottom: "10px",
          color: "#E91E63",
          fontSize: "17px",
        }}
      />
      <div style={{ height: "300px" }}>
        <Pie ref={chartRef} data={data} options={options} />
      </div>
    </div>
  )
}

export default StatsPieChart
